import { useClientContext } from '@/context/client'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ClientOwnerIdentificationForm } from './client-owner-identification-form'

export function ClientInfoDisplay() {
  const { informacoes } = useClientContext()

  if (!informacoes) return null

  return (
    <Card className="mt-4">
      <Card>
        <CardHeader>
          <CardTitle>Informações do CNPJ</CardTitle>
        </CardHeader>
        <CardContent>
          <p>
            <strong>Razão Social:</strong> {informacoes.razao_social}
          </p>
          <p>
            <strong>CNAE:</strong> {informacoes.cnae}
          </p>
          <p>
            <strong>Endereço:</strong> {informacoes.endereco}
          </p>

          <div className="min-w-64 w-full mx-auto pt-3">
            <ClientOwnerIdentificationForm />
          </div>
        </CardContent>
      </Card>
    </Card>
  )
}
